import React, { Fragment, useState, useEffect, useMemo } from "react";
import moment from "moment";
import _ from "lodash"; // Make sure you have lodash installed
import { LightOnIcon } from "../../common/CustomIcon";
import I18n from "../../common/I18n";

const QuickDispatchapptError = React.memo((props) => {
  const [errorOrders, setErrorOrders] = useState([]);
  const { orders, selectedDate, showApptErrors, setShowApptErrors } = props;

  // Memoize the calculateErrorOrders function
  const calculateErrorOrders = useMemo(() => {
    const givenDate = moment(selectedDate).format("YYYY-MM-DD");
    const result = _.filter(orders, (order) => {
      // Orders with top-level appointments array
      if (order?.appointments) {
        const activeAppointments = order.appointments.filter(
          (apt) => apt?.status !== "COMPLETED"
        );

        if (!activeAppointments.length) return false;

        return !activeAppointments.some((appointment) =>
          appointment?.start_datetime?.startsWith(givenDate)
        );
      }

      // Orders without appointments key in orders (use origin/destination)
      const key = order?.order_type === "PICKUP" ? "origin" : "destination";
      const locationStatus = order?.[key]?.status;

      if (locationStatus === "COMPLETED") return false;

      const apptDate = order?.[key]?.appointment?.appt_date;

      // If no appointments, show nothing
      if (!apptDate) {
        return false;
      }

      return !apptDate?.startsWith(givenDate);
    }).map((order) => order?.customer_order_number);

    return result;
  }, [orders, selectedDate]);

  useEffect(() => {
    const result = calculateErrorOrders;
    setErrorOrders(result);
    setShowApptErrors(result.length > 0);
  }, [calculateErrorOrders, setShowApptErrors]);

  return showApptErrors && errorOrders?.length ? (
    <div className="error-container">
      <p>{I18n.t("general.appointment") + "(s) mismatch"}</p>
      <p className="description" style={{ maxHeight: 60, overflowY: "auto" }}>
        The order's {
          errorOrders.join(', ')
        } appointments are not matching with selected date.
      </p>
      <span
        className="dismiss-tip"
        onClick={() => {
          setShowApptErrors(false);
        }}
      >
        Dismiss
      </span>
      <div className="icon">
        {" "}
        <LightOnIcon color="red" />{" "}
      </div>
    </div>
  ) : (
    <Fragment />
  );
});

export default QuickDispatchapptError;
